export default "__VITE_ASSET__DNekrqDQ__"